<template>
  <div class="detail">
    <div class="banner">
      <div class="container">
        <div class="title-blue">联盟新闻</div>
      </div>
    </div>
    <div class="detail-wrap">
      <div class="news-container">
        <div class="bread-crumb">
          <span>CEATI新闻 > </span>
          <span class="current">{{ newsData.title }}</span>
        </div>
        <div class="news-title">
          <h3>{{ newsData.title }}</h3>
          <em>发布日期: {{ newsData.date_format}} 作者: {{ newsData.author }}</em>
        </div>
        <div class="news-detail" v-html="newsData.content"></div>
        <div class="news-footer">
          <el-button class="btn prev iconfont iconPRE" type="text" :disabled="prevNewsId===''" @click="handleJump(prevNewsId)">上一篇</el-button>
          <el-button class="btn next iconfont iconNEXT" type="text"  :disabled="nextNewsId===''" @click="handleJump(nextNewsId)">下一篇</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsDetail, getAdjoinNews } from '@/api/api'
export default {
  name: 'Detail',
  data () {
    return {
      newsData: {
        title: '',
        content: '',
        author: '',
        date_format: ''
      },
      prevNewsId: '',
      nextNewsId: ''
    }
  },
  watch: {
    '$route': function () {
      this.$router.go(0)
    }
  },
  mounted () {
    const { id } = this.$route.params;
    const params = {
      site: 'zgZbDQmr7lD7P8lV61vR',
      id
    }
    getNewsDetail(params).then(data => {
      this.newsData = data.data.data;
    })
    getAdjoinNews(params).then(data => {
      this.nextNewsId = Array.isArray(data.data.data.after) ? '' : data.data.data.after.gid;
      this.prevNewsId = Array.isArray(data.data.data.pre) ? '' : data.data.data.pre.gid;
    })
  },
  methods: {
    handleJump (gid) {
      // console.log('id', gid);
      this.$router.push({
        name: 'detail',
        params: {
          id: gid
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .banner {
    background: url(~@/assets/images/img-bg.png) right top no-repeat #EBF1FF;
    .container {
      width: 1200px;
      margin: 0 auto;
      padding: 48px 0 62px 0;
      .title-blue {
        margin-bottom: 48px;
      }
    }
  }
  .detail-wrap {
    background: #FBFBFB;
    // margin-bottom: -60px;
  }
  .news-container {
    background: #FFFFFF;
    width: 1200px;
    margin: 0 auto;
    box-shadow: 0 0 10px 0 rgba(0,0,0,0.08);
    padding: 24px 32px;
    position: relative;
    top: -60px
  }
  .bread-crumb {
      text-align: left;
      font-size: 14px;
      color: #999999;
      margin-bottom: 24px;
      .current {
        color: #2A2A2A;
      }
    }
    .news-title {
      background-color: #FBFBFB;
      padding-top: 42px;
      padding-bottom: 32px;
      // height: 142px;
      h3 {
        font-size: 24px;
        color: #333333;
        text-align: center;
        margin-bottom: 24px;
        width: 960px;
        margin: 0 auto;
        line-height: 32px;
      }
      em {
        font-size: 12px;
        font-style: normal;
        color: #999999;
        text-align: center;
        display: block;
        margin-top: 24px;
      }
    }
    .news-detail {
      padding: 40px 16px 16px 16px;
      /deep/ p {
        font-size: 14px;
        color: #666666;
        text-align: justify;
        line-height: 28px;
        margin-bottom: 45px;
        img {
          display: block;
          margin: 0 auto;
          max-width: 100%;
        }
      }
    }
    .news-footer {
      /deep/ .el-button {
        display: inline-block;
        height: 48px;
        width: 200px;
        background: #FFFFFF;
        border: 1px solid #CCCCCC;
        font-size: 14px;
        color: #666666;
        margin: 0 8px;
        &:hover {
          background: #CCDDFF;
          border: 1px solid #004CE6;
          color: #004CE6;
        }
      }
      /deep/ .is-disabled, .is-disabled:hover {
        color: #CCCCCC;
        background: #F2F2F2;
        border: 1px solid #E6E6E6;
      }
      .btn {
        border-radius: 0;
      }
      .next {
        /deep/ span{
          position: relative;
          top: -2px;
        }
      }
      .prev {
        /deep/ span {
          position: relative;
          top: -2px;
        }
      }
    }
</style>
